// extracted by mini-css-extract-plugin
export default {"options":"XiRS7","logo-wrapper":"DRyHP","logo":"wT81k","logo--is-compact":"_1DBH2","form":"g85KK","no-report":"YDkA5"};